function ScopeComponent(Component) {
  if (!Component.mounted) {
    Component.mounted = [];
  } else if (!Array.isArray(Component.mounted)) {
    Component.mounted = [Component.mounted];
  }
  Component.mounted.push(function() {
    this.$el.setAttribute(`data-v-${"1e35ee1"}`, "");
  });
}
export {
  ScopeComponent as S
};
//# sourceMappingURL=ScopeComponent-77Az-4PS.mjs.map
